import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Spinner, FormGroup, CustomInput } from "reactstrap";
import {
  DayCountFractions,
  PaymentBase,
  PaymentFormula,
  IssuanceType,
  IndexType,
  CallPut,
  FundType,
  YesNo,
  QuotingType,
  Decimals,
  WizzMode,
  OfferType,
  SectorType,
  PaymentRateType,
} from "../../types";
import { Suggest, LoadingMessage, FormNumber, LoadingField, FormSelect, FormCheck } from "./../../Controls";
import AssetSubClass from "./AssetSubClass";
import { FormField } from "../../../..";
import { parseDate } from "./../../Modals/ModalQuote";
import style from "./styles.module.scss";

const Structure = ({ mode, services, fields, previousFields, entities, wizzOnChange }) => {
  const [readonly, setReadonly] = useState(false);

  useEffect(() => {
    if (mode) {
      setReadonly(mode == WizzMode.View);
    }
  }, [mode]);

  const [UseAssetAnnualTargetPerfomance, setShowAnnualTargetPerformance] = useState(false);
  const [UseAssetQualified, setShowIsQualified] = useState(false);

  useEffect(() => {
    if (services.getParameterValue) {
            services.getParameterValue({ ParameterName: "UseAssetAnnualTargetPerfomance" }, (response) => {
          if (response && response.SdtParametersData && response.SdtParametersData.ParameterNumericValue == 1) {
            setShowAnnualTargetPerformance(true);
          }
        });
      }
      services.getParameterValue({ ParameterName: "UseAssetQualification" }, (response) => {
          if (response && response.SdtParametersData && response.SdtParametersData.ParameterNumericValue == 1) {
            setShowIsQualified(true);
          }
        });
  }, [services])

  const onChange = (name, value) => {
    wizzOnChange({ [name]: value });
  };

  const onChangeDate = (name, value) => {
    wizzOnChange({ [name]: parseDate(value) });
  };

  const onChangeSuggest = (name, values) => {
    wizzOnChange(values);
  };

  const onChangeCheck = (event) => {
    const { id, checked } = event.target;
    wizzOnChange({ [id]: checked });
  };

  const { currencies, calendars } = entities;
  const { SubAssetClassInfo: subAsset } = fields || {};

  return (
    <div>
      <AssetSubClass subAsset={subAsset} />
      <span className={style.sectionDark}>Asset section</span>
      {fields ? (
        <Fragment>
          <Row>
            <Col>
              <FormField
                name="AssetDescription"
                label="Description"
                value={fields.AssetDescription}
                disabled={readonly}
                onChange={onChange}
                changedColor={fields.AssetDescription != previousFields.AssetDescription}
              />
            </Col>
          </Row>
          <Row>
            <Col lg="2">
              {currencies ? (
                <FormSelect
                  name="CurrencyId"
                  label="Quoting currency"
                  selectItems={currencies}
                  getSelectItemId={(i) => i.currencyId}
                  getSelectItemName={(i) => i.currencyISO}
                  value={fields.CurrencyId}
                  disabled={readonly}
                  onChange={onChange}
                  changedColor={fields.CurrencyId != previousFields.CurrencyId}
                />
              ) : (
                <Spinner size="sm" />
              )}
            </Col>
            <Col lg="2">
              <FormField
                name="AssetDefaultSettlement"
                label="Default settlement"
                type="number"
                value={fields.AssetDefaultSettlement}
                disabled={readonly}
                onChange={onChange}
                changedColor={fields.AssetDefaultSettlement != previousFields.AssetDefaultSettlement}
                dataTypeDecimalName="currency"
              />
            </Col>
            {subAsset.SubAssetClassHasRegularPayments && (
              <Col lg="2">
                <FormSelect
                  name="AssetAccrualType"
                  label="Accrual type"
                  selectItems={DayCountFractionsValues}
                  getSelectItemId={(i) => i.id}
                  getSelectItemName={(i) => i.description}
                  value={fields.AssetAccrualType}
                  disabled={readonly}
                  onChange={onChange}
                  changedColor={fields.AssetAccrualType != previousFields.AssetAccrualType}
                />
              </Col>
            )}
            {subAsset.SubAssetClassHasRegularPayments && (
              <Col lg="2">
                <FormSelect
                  name="AssetAccrualTypeEOM"
                  label="Accrual Type EOM"
                  selectItems={YesNoValues}
                  getSelectItemId={(i) => i.id}
                  getSelectItemName={(i) => i.description}
                  value={parseYesNo(fields.AssetAccrualTypeEOM)}
                  disabled={readonly}
                  onChange={(name, value) => onChange(name, +value)}
                  changedColor={fields.AssetAccrualTypeEOM != previousFields.AssetAccrualTypeEOM}
                />
              </Col>
            )}
          </Row>
          {subAsset.SubAssetClassHasRegularPayments && (
            <Fragment>
              <span className={style.section}>Coupon/Dividend info</span>
              <Row>
                {subAsset.SubAssetClassHasRegularPayments && (
                  <Fragment>
                    <Col lg="2">
                      <FormField
                        name="AssetCouponDividendPaymentFrecuency"
                        label="Payment frecuency"
                        type="number"
                        value={fields.AssetCouponDividendPaymentFrecuency}
                        disabled={readonly}
                        onChange={onChange}
                        changedColor={
                          fields.AssetCouponDividendPaymentFrecuency !=
                          previousFields.AssetCouponDividendPaymentFrecuency
                        }
                        dataTypeDecimalName="currency"
                      />
                    </Col>
                    <Col lg="2">
                      <FormSelect
                        name="AssetCouponDividendPaymentBase"
                        label="Payment base"
                        selectItems={PaymentBaseValues}
                        getSelectItemId={(i) => i.id}
                        getSelectItemName={(i) => i.description}
                        value={fields.AssetCouponDividendPaymentBase}
                        disabled={readonly}
                        onChange={onChange}
                        changedColor={
                          fields.AssetCouponDividendPaymentBase !=
                          previousFields.AssetCouponDividendPaymentBase
                        }
                      />
                    </Col>
                  </Fragment>
                )}

                {subAsset.SubAssetClassHasRegularPayments && (
                  <Fragment>
                    <Col lg="2">
                      <FormField
                        name="AssetFirstCouponDate"
                        label="First coupon/dividend date"
                        type="date"
                        value={parseDate(fields.AssetFirstCouponDate)}
                        disabled={readonly}
                        onChange={onChangeDate}
                        changedColor={fields.AssetFirstCouponDate != previousFields.AssetFirstCouponDate}
                      />
                    </Col>
                  </Fragment>
                )}
              </Row>
            </Fragment>
          )}
          <Row>
            {(subAsset.SubAssetClassPaymentType == PaymentFormula.InterestRate ||
              subAsset.SubAssetClassPaymentType == PaymentFormula.EffectiveRate) && (
              <Fragment>
                <Col lg="2">
                  <FormSelect
                    name="AssetHasPartialRedemptions"
                    label="Has Partial Redemptions"
                    selectItems={YesNoValues}
                    getSelectItemId={(i) => i.id}
                    getSelectItemName={(i) => i.description}
                    value={parseYesNo(fields.AssetHasPartialRedemptions)}
                    disabled={readonly}
                    onChange={(name, value) => onChange(name, +value)}
                    changedColor={
                      fields.AssetHasPartialRedemptions != previousFields.AssetHasPartialRedemptions
                    }
                  />
                </Col>
                <Col lg="2">
                  <FormSelect
                    name="AssetHasCapitalizations"
                    label="Has Capitalizations"
                    selectItems={YesNoValues}
                    getSelectItemId={(i) => i.id}
                    getSelectItemName={(i) => i.description}
                    value={parseYesNo(fields.AssetHasCapitalizations)}
                    disabled={readonly}
                    onChange={(name, value) => onChange(name, +value)}
                    changedColor={fields.AssetHasCapitalizations != previousFields.AssetHasCapitalizations}
                  />
                </Col>
              </Fragment>
            )}
            {subAsset.SubAssetClassQuoting == QuotingType.Contracts && (
              <Col lg="2">
                <FormField
                  name="AssetContractSize"
                  label="Contract size"
                  type="number"
                  value={fields.AssetContractSize}
                  disabled={readonly}
                  onChange={onChange}
                  changedColor={fields.AssetContractSize != previousFields.AssetContractSize}
                  dataTypeDecimalName="currency"
                />
              </Col>
            )}
          </Row>

          {(subAsset.SubAssetClassPaymentType == PaymentFormula.InterestRate ||
            subAsset.SubAssetClassPaymentType == PaymentFormula.EffectiveRate ||
            (subAsset.SubAssetClassPaymentType == PaymentFormula.Dividend &&
              subAsset.SubAssetClassHasRegularPayments)) && (
            <Row>
              <Col lg="2">
                <FormSelect
                  name="AssetPaymentRateType"
                  label="Payment rate type"
                  selectItems={PaymentRateTypeValues}
                  getSelectItemId={(i) => i.id}
                  getSelectItemName={(i) => i.description}
                  value={fields.AssetPaymentRateType}
                  disabled={readonly}
                  onChange={onChange}
                  changedColor={fields.AssetPaymentRateType != previousFields.AssetPaymentRateType}
                />
              </Col>
              <Col lg="2">
                <FormField
                  name="AssetPaymentRateFixed"
                  label="Payment rate fixed"
                  type="number"
                  value={fields.AssetPaymentRateFixed}
                  disabled={readonly}
                  onChange={onChange}
                  changedColor={fields.AssetPaymentRateFixed != previousFields.AssetPaymentRateFixed}
                  dataTypeDecimalName="currency"
                />
              </Col>
              <Col>
                <FormField
                  name="AssetPaymentRateVariableExpression"
                  label="Payment rate variable expression"
                  type="text"
                  value={fields.AssetPaymentRateVariableExpression}
                  disabled={readonly}
                  onChange={onChange}
                  changedColor={
                    fields.AssetPaymentRateVariableExpression !=
                    previousFields.AssetPaymentRateVariableExpression
                  }
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col lg="2">
              <FormSelect
                name="AssetHasIndex"
                label="Has index"
                selectItems={YesNoValues}
                getSelectItemId={(i) => i.id}
                getSelectItemName={(i) => i.description}
                value={parseYesNo(fields.AssetHasIndex)}
                disabled={readonly}
                onChange={(name, value) => onChange(name, +value)}
                changedColor={fields.AssetHasIndex != previousFields.AssetHasIndex}
              />
            </Col>

            {subAsset.SubAssetClassHasMaturity && (
              <Col lg="2">
                <FormField
                  name="AssetMaturityDate"
                  label="Maturity date"
                  type="date"
                  value={parseDate(fields.AssetMaturityDate)}
                  disabled={readonly}
                  onChange={onChangeDate}
                  changedColor={fields.AssetMaturityDate != previousFields.AssetMaturityDate}
                />
              </Col>
            )}

            {fields.AssetHasIndex == YesNo.Yes && (
              <Fragment>
                <Col lg="2">
                  <FormSelect
                    name="AssetIndex"
                    label="Asset Index"
                    selectItems={IndexTypeValues}
                    getSelectItemId={(i) => i.description}
                    getSelectItemName={(i) => i.description}
                    value={fields.AssetIndex}
                    disabled={readonly}
                    onChange={onChange}
                    changedColor={fields.AssetIndex != previousFields.AssetIndex}
                  />
                </Col>
                <Col>
                  <FormField
                    name="AssetIndexExpression"
                    label="Index expression"
                    type="text"
                    value={fields.AssetIndexExpression}
                    disabled={readonly}
                    onChange={onChange}
                    changedColor={fields.AssetIndexExpression != previousFields.AssetIndexExpression}
                  />
                </Col>
              </Fragment>
            )}
          </Row>

          <Row>
            <Col lg="2">
              <FormNumber
                name="AssetParValue"
                label="Par value"
                value={fields.AssetParValue}
                disabled={readonly}
                onChange={onChange}
                changedColor={fields.AssetParValue != previousFields.AssetParValue}
                dataTypeDecimalName="currency"
              />
            </Col>
            {subAsset.SubAssetClassPricesDirty && (
              <Col className={style.checkbox}>
                <FormGroup className="mt-4">
                  <FormCheck
                    name="AssetPricesDirty"
                    label="Prices dirty"
                    value={fields.AssetPricesDirty}
                    onChange={onChangeCheck}
                    disabled={readonly}
                    changedColor={fields.AssetPricesDirty != previousFields.AssetPricesDirty}
                  />
                </FormGroup>
              </Col>
            )}
          </Row>
          {subAsset.SubAssetClassIsanOption && (
            <Fragment>
              <span className={style.section}>Option specific info</span>
              <Row>
                <Col lg="3" className={style.checkbox}>
                  <FormGroup className="mt-4">
                    <FormCheck
                      name="AssetHasCall"
                      label="Asset Has Callable"
                      value={fields.AssetHasCall}
                      onChange={onChangeCheck}
                      disabled={readonly}
                      changedColor={fields.AssetHasCall != previousFields.AssetHasCall}
                    />
                  </FormGroup>
                </Col>
                <Col lg="3">
                  <Suggest
                    name="AssetUnderlyingAsset"
                    label="Underlying Asset"
                    fieldId="AssetUnderlyingAsset"
                    fieldName="AssetUnderlyingAssetName"
                    valueId={fields.AssetUnderlyingAsset}
                    valueName={fields.AssetUnderlyingAssetName}
                    getSelectItemId={(i) => i.Id}
                    getSelectItemName={(i) => i.Ticker}
                    service={services.searchSymbol}
                    disabled={readonly}
                    onChange={onChangeSuggest}
                    changedColor={fields.AssetUnderlyingAsset != previousFields.AssetUnderlyingAsset}
                  />
                </Col>
                <Col>
                  <FormField
                    name="AssetStrikePrice"
                    label="Strike price"
                    type="text"
                    value={fields.AssetStrikePrice}
                    disabled={readonly}
                    onChange={onChange}
                    changedColor={fields.AssetStrikePrice != previousFields.AssetStrikePrice}
                  />
                </Col>
                <Col>
                  <FormField
                    name="AssetCallDate"
                    label="Call date"
                    type="date"
                    value={parseDate(fields.AssetCallDate)}
                    disabled={readonly}
                    onChange={onChangeDate}
                    changedColor={fields.AssetCallDate != previousFields.AssetCallDate}
                  />
                </Col>
                <Col>
                  <FormSelect
                    name="AssetIsCallPut"
                    label="Call/Put"
                    selectItems={CallPutValues}
                    getSelectItemId={(i) => i.id}
                    getSelectItemName={(i) => i.description}
                    value={fields.AssetIsCallPut}
                    disabled={readonly}
                    onChange={onChange}
                    changedColor={fields.AssetIsCallPut != previousFields.AssetIsCallPut}
                  />
                </Col>
              </Row>
            </Fragment>
          )}

          <Row>
            <Col lg="3">
              <Suggest
                name="CountryId"
                label="Country"
                fieldId="CountryId"
                fieldName="CountryName"
                fieldExtension="CountryISO2"
                valueId={fields.CountryId}
                valueName={fields.CountryName}
                getSelectItemId={(i) => i.Id}
                getSelectItemName={(i) => i.Name}
                getSelectItemExtension={(i) => i.Code}
                service={services.searchCountry}
                disabled={readonly}
                onChange={onChangeSuggest}
                changedColor={fields.CountryId != previousFields.CountryId}
              />
            </Col>

            <Col lg="3">
              <Suggest
                name="CountryISO2"
                label="Country ISO2"
                fieldId="CountryId"
                fieldName="CountryISO2Name"
                fieldExtension="CountryName"
                valueId={fields.CountryISO2}
                valueName={fields.CountryISO2}
                getSelectItemId={(i) => i.Id}
                getSelectItemName={(i) => i.Name}
                getSelectItemExtension={(i) => i.Description}
                service={services.searchCountryISO2}
                disabled={readonly}
                onChange={onChangeSuggest}
                changedColor={fields.CountryId != previousFields.CountryId}
              />
            </Col>
          </Row>
          <Row>
            <Col lg="3">
              {currencies ? (
                <FormSelect
                  name="AssetIssuanceCurrency"
                  label="Issuance currency"
                  selectItems={currencies}
                  getSelectItemId={(i) => i.currencyId}
                  getSelectItemName={(i) => i.currencyISO}
                  value={fields.AssetIssuanceCurrency}
                  disabled={readonly}
                  onChange={onChange}
                  changedColor={fields.AssetIssuanceCurrency != previousFields.AssetIssuanceCurrency}
                />
              ) : (
                <Spinner size="sm" />
              )}
            </Col>
            <Col lg="3">
              <FormSelect
                name="AssetIssuanceType"
                label="Issuance Type"
                selectItems={IssuanceTypeValues}
                getSelectItemId={(i) => i.id}
                getSelectItemName={(i) => i.description}
                value={fields.AssetIssuanceType}
                disabled={readonly}
                onChange={onChange}
                changedColor={fields.AssetIssuanceType != previousFields.AssetIssuanceType}
              />
            </Col>
            {subAsset.SubAssetClassRequieresIssuanceDate && (
              <Col lg="2">
                <FormField
                  name="AssetIssuanceDate"
                  label="Issuance date"
                  type="date"
                  value={parseDate(fields.AssetIssuanceDate)}
                  disabled={readonly}
                  onChange={onChangeDate}
                  changedColor={fields.AssetIssuanceDate != previousFields.AssetIssuanceDate}
                />
              </Col>
            )}
            <Col lg="4">
              <Suggest
                name="IssuerId"
                label="Issuer"
                fieldId="IssuerId"
                fieldName="IssuerName"
                valueId={fields.IssuerId}
                valueName={fields.IssuerName}
                getSelectItemId={(i) => i.Id}
                getSelectItemName={(i) => i.Value}
                service={services.searchIssuer}
                serviceCreateIssuer={services.createIssuer}
                disabled={readonly}
                onChange={onChangeSuggest}
                changedColor={fields.IssuerId != previousFields.IssuerId}
              />
            </Col>
          </Row>

          <Row>
            <Col lg="3">
              <FormSelect
                name="AssetOfferType"
                label="Offer type"
                selectItems={OfferTypeValues}
                getSelectItemId={(i) => i.id}
                getSelectItemName={(i) => i.description}
                value={fields.AssetOfferType}
                disabled={readonly}
                onChange={onChange}
                changedColor={fields.AssetOfferType != previousFields.AssetOfferType}
              />
            </Col>

            <Col lg="3">
              <FormSelect
                name="AssetSectorType"
                label="Sector type"
                selectItems={SectorTypeValues}
                getSelectItemId={(i) => i.id}
                getSelectItemName={(i) => i.description}
                value={fields.AssetSectorType}
                disabled={readonly}
                onChange={onChange}
                changedColor={fields.AssetSectorType != previousFields.AssetSectorType}
              />
            </Col>

            <Col lg="2" className={style.checkbox}>
              <FormGroup className="mt-4">
                <FormCheck
                  name="AssetCanBeTraded"
                  label="Can be traded by clients"
                  value={fields.AssetCanBeTraded}
                  onChange={onChangeCheck}
                  disabled={readonly}
                  changedColor={fields.AssetCanBeTraded != previousFields.AssetCanBeTraded}
                />
              </FormGroup>
            </Col>

            <Col lg="2" className={style.checkbox}>
              <FormGroup className="mt-4">
                <FormCheck
                  name="AssetCanBeTradedProp"
                  label="Can be traded by prop"
                  value={fields.AssetCanBeTradedProp}
                  onChange={onChangeCheck}
                  disabled={readonly}
                  changedColor={fields.AssetCanBeTradedProp != previousFields.AssetCanBeTradedProp}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col lg="3">
              <Suggest
                name="AssetPreferredCustodianEntity"
                label="Custodian Entity"
                fieldId="AssetPreferredCustodianEntity"
                fieldName="AssetPreferredCustodianEntityName"
                valueId={fields.AssetPreferredCustodianEntity}
                valueName={fields.AssetPreferredCustodianEntityName}
                getSelectItemId={(i) => i.Id}
                getSelectItemName={(i) => i.Value}
                service={services.searchCustEntity}
                disabled={readonly}
                onChange={onChangeSuggest}
                changedColor={
                  fields.AssetPreferredCustodianEntity != previousFields.AssetPreferredCustodianEntity
                }
              />
            </Col>

            <Col lg="3">
              {calendars ? (
                <FormSelect
                  name="AssetDefaultCalendar"
                  label="Default Calendar"
                  selectItems={calendars}
                  getSelectItemId={(i) => i.CalendarId}
                  getSelectItemName={(i) => i.CalendarName}
                  disabled={readonly}
                  value={fields.AssetDefaultCalendar == 0 ? -1 : fields.AssetDefaultCalendar}
                  onChange={onChange}
                  changedColor={fields.AssetDefaultCalendar != previousFields.AssetDefaultCalendar}
                />
              ) : (
                <LoadingField label="Default Calendar" />
              )}
            </Col>

            <Col className={style.checkbox}>
              <FormGroup className="mt-4">
                <FormCheck
                  name="AssetCanBeSelfCustodied"
                  label="Can be blocked in special custody"
                  value={fields.AssetCanBeSelfCustodied}
                  onChange={onChangeCheck}
                  disabled={readonly}
                  changedColor={fields.AssetCanBeSelfCustodied != previousFields.AssetCanBeSelfCustodied}
                />
              </FormGroup>
            </Col>
            {UseAssetQualified && (
              <Col lg="2" className={style.checkbox}>
                <FormGroup className="mt-4">
                  <FormCheck
                    name="AssetIsQualified"
                    label="Is Qualified"
                    value={fields.AssetIsQualified}
                    onChange={onChangeCheck}
                    disabled={readonly}
                    changedColor={fields.AssetIsQualified != previousFields.AssetIsQualified}
                  />
              </FormGroup>
              </Col>
            )}
          </Row>
          {subAsset.SubAssetClassIsFund && (
            <Fragment>
              <span className={style.section}>Fund specific info</span>
              <Row>
                <Col lg="2">
                  <FormSelect
                    name="AssetFundType"
                    label="Fund type"
                    selectItems={FundTypeValues}
                    getSelectItemId={(i) => i.id}
                    getSelectItemName={(i) => i.description}
                    value={fields.AssetFundType}
                    disabled={readonly}
                    onChange={onChange}
                    changedColor={fields.AssetFundType != previousFields.AssetFundType}
                  />
                </Col>

                <Col lg="2" className={style.checkbox}>
                  <FormGroup className="mt-4">
                    <FormCheck
                      name="AssetHasPenalties"
                      label="Has Penalties"
                      value={fields.AssetHasPenalties}
                      onChange={onChangeCheck}
                      disabled={readonly}
                      changedColor={fields.AssetHasPenalties != previousFields.AssetHasPenalties}
                    />
                  </FormGroup>
                </Col>

                <Col lg="2" className={style.checkbox}>
                  <FormGroup className="mt-4">
                    <FormCheck
                      name="AssetFundReinvests"
                      label="Fund Reinvests"
                      value={fields.AssetFundReinvests}
                      onChange={onChangeCheck}
                      disabled={readonly}
                      changedColor={fields.AssetFundReinvests != previousFields.AssetFundReinvests}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Fragment>
          )}
          <span className={style.section}>Others</span>
          <Row>
            <Col lg="2">
              <FormField
                name="AssetMin"
                label="Min"
                type="text"
                value={+fields.AssetMin}
                disabled={readonly}
                onChange={onChange}
                changedColor={fields.AssetMin != previousFields.AssetMin}
              />
            </Col>
            <Col lg="2">
              <FormField
                name="AssetMultiple"
                label="Increments"
                type="text"
                value={+fields.AssetMultiple}
                disabled={readonly}
                onChange={onChange}
                changedColor={fields.AssetMultiple != previousFields.AssetMultiple}
              />
            </Col>
            {subAsset.SubAssetClassIsFund && (
              <Col lg="2">
                <FormSelect
                  name="AssetMaxDecimals"
                  label="Max Decimals"
                  selectItems={DecimalsValues}
                  getSelectItemId={(i) => i.id}
                  getSelectItemName={(i) => i.description}
                  value={fields.AssetMaxDecimals}
                  disabled={readonly}
                  onChange={onChange}
                  changedColor={fields.AssetMaxDecimals != previousFields.AssetMaxDecimals}
                />
              </Col>
            )}
            {UseAssetAnnualTargetPerfomance && subAsset.SubAssetClassIsFund && (
              <Col lg="2">
                <FormField
                  name="AssetAnnualTargetPerformance"
                  label="Annual Target Performance"
                  type="text"
                  value={fields.AssetAnnualTargetPerformance}
                  disabled={readonly}
                  onChange={onChange}
                  changedColor={fields.AssetAnnualTargetPerformance != previousFields.AssetAnnualTargetPerformance}
                />
              </Col>
            )}
            <Col lg="2">
              <Suggest
                name="RiskRegionId"
                label="Risk Region"
                fieldId="RiskRegionId"
                fieldName="RiskRegionName"
                valueId={fields.RiskRegionId}
                valueName={fields.RiskRegionName}
                getSelectItemId={(i) => i.Id}
                getSelectItemName={(i) => i.Value}
                service={services.searchRegion}
                disabled={readonly}
                onChange={onChangeSuggest}
                changedColor={fields.RiskRegionId != previousFields.RiskRegionId}
              />
            </Col>
          </Row>
        </Fragment>
      ) : (
        <LoadingMessage text="Retriving asset info" />
      )}
    </div>
  );
};

export default Structure;

const parseYesNo = (value) => (value ? 1 : 0);

const DayCountFractionsValues = Object.entries(DayCountFractions).map(([key, value]) => ({
  id: value,
  description: value,
}));

const PaymentBaseValues = Object.entries(PaymentBase).map(([key, value]) => ({
  id: key,
  description: value,
}));

const PaymentFormulaValues = Object.entries(PaymentFormula).map(([key, value]) => ({
  id: key,
  description: value,
}));

const IndexTypeValues = Object.entries(IndexType).map(([key, value]) => ({
  id: key,
  description: value,
}));

const CallPutValues = Object.entries(CallPut).map(([key, value]) => ({
  id: key,
  description: value,
}));

const OfferTypeValues = Object.entries(OfferType).map(([key, value]) => ({
  id: key,
  description: value,
}));

const PaymentRateTypeValues = Object.entries(PaymentRateType).map(([key, value]) => ({
  id: key,
  description: value,
}));

const SectorTypeValues = Object.entries(SectorType).map(([key, value]) => ({
  id: key,
  description: value,
}));

const IssuanceTypeValues = Object.entries(IssuanceType).map(([key, value]) => ({
  id: key,
  description: value,
}));

const FundTypeValues = Object.entries(FundType).map(([key, value]) => ({
  id: key,
  description: value,
}));

const YesNoValues = Object.entries(YesNo).map(([value, key]) => ({
  id: key,
  description: value,
}));

const DecimalsValues = Object.entries(Decimals).map(([value, key]) => ({
  id: key,
  description: value,
}));

export function validateStruture(fields) {
  const fieldNames = [];
  const errors = {};

  fieldNames.forEach((name) => {
    if (fields[name] == undefined || fields[name] == "") {
      errors[name] = "Required field";
    }
  });

  return errors;
}
